var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 536 327",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CMA_CGM"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FF0000",
    d: "M300.5,35.8c3.8-3,20.5-17.9,28.8-28.1c0.6-0.8,0.2-1.9-0.7-2.2c-43.7-12.7-176-0.4-238.8,94.7 c-0.9,1.3-0.7,1.7,0.3,2.5c21.9-35.5,71.6-63.4,131.7-69.2c24.7-2.4,49.9-0.4,74.7,3.9C298.9,37.6,298.8,37.2,300.5,35.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#051039",
    d: "M239.3,201.2h17.5l-30.9-75h-22.8l-30.9,75h17l5-13h40L239.3,201.2z M200.3,174.2l13.9-36.3l13.9,36.3 H200.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#051039",
    d: "M127.5,193.2l19.1-31.9c0.7-1.2,4.4-7.6,5.6-10.1h0.2c-0.2,2.8-0.2,7.8-0.2,10.1v39.9h16v-75h-15.3 l-24.3,40.2l-24.3-40.2H86.2v75h16v-39.9c0-2.3-0.1-7.2-0.2-10.1h0.2c1.2,2.4,4.9,8.9,5.6,10.1l19.1,31.9L127.5,193.2 L127.5,193.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#051039",
    d: "M492,193.2l19.5-31.9c0.7-1.2,4.5-7.6,5.7-10.1h0.2c-0.2,2.8-0.2,7.8-0.2,10.1v39.9h16v-75h-16.3 l-24.3,40.2l-24.3-40.2h-18.1v75h16v-39.9c0-2.3-0.1-7.2-0.2-10.1h0.2c1.2,2.4,5,8.9,5.7,10.1l19.5,31.9L492,193.2L492,193.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#051039",
    d: "M77.2,179.2h-17v0.5c0,6.1-3.3,7.5-10.6,7.5H33.4c-12.3,0-14.2-1.5-14.2-15.8V155 c0-13.3,1.8-14.8,13.9-14.8H49c7.2,0,10.4,1.3,10.4,7h18.9c0-16.4-6.5-22-26.9-22H30.2c-19.4,0-27,7.3-27,26.2v23.9 c0,18.5,7.5,25.8,26.6,25.8h20.9c20.2,0,26.5-5.5,26.5-21.6V179.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#051039",
    d: "M354.2,179.2h-17v0.5c0,6.1-3.3,7.5-10.6,7.5h-16.2c-12.3,0-14.2-1.5-14.2-15.8V155 c0-13.3,1.8-14.8,13.9-14.8H326c7.2,0,10.4,1.3,10.4,7h18.9c0-16.4-6.5-22-26.9-22h-21.2c-19.4,0-27,7.4-27,26.3v23.9 c0,18.5,7.5,25.7,26.6,25.7h20.9c20.2,0,26.5-5.5,26.5-21.5V179.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#051039",
    d: "M423.2,172.2v7.9c0,5.8-3.2,7.1-10.5,7.1h-19.4c-12.2,0-14-1.4-14-15V155c0-13.3,1.8-14.8,13.9-14.8 h18.5c7.2,0,10.4,1.3,10.4,7h18.9c0-16.4-6.5-22-26.9-22h-23.7c-19.4,0-27,7.4-27,26.3V175c0,18.8,7.5,26.2,26.4,26.2h23.2 c20.1,0,26.3-5.6,26.3-21.9v-20.1h-38v13H423.2z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0000",
    d: "M235.5,290.2c-3.8,3-20.5,17.9-28.8,28.1c-0.6,0.8-0.2,1.9,0.7,2.2c43.7,12.7,176,0.3,238.8-94.8 c0.9-1.3,0.7-1.7-0.3-2.5c-21.9,35.5-71.6,63.4-131.7,69.2c-24.7,2.4-49.9,0.4-74.7-3.9C237.1,288.3,237.2,288.7,235.5,290.2z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ANL"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_4_-_copie",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FF0000",
    d: "M-61.4,88.2c0,0,44-26.3,96.5-9.2c0,0-22.8,33.9-28.6,81.6c0,0-32.8-20.3-82-1L-61.4,88.2z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-14.1,102.6 8.5,100.9 -11.6,115.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "-7.4,122 4,121.1 -4.4,115.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#051039",
    d: "M-34.3,253.3h-16l27.8-67.7h20.6L26,253.3H9.6l-4.4-11.4h-35L-34.3,253.3z M-24.9,229H0.2l-12.6-32.7 L-24.9,229z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#051039",
    d: "M83.4,253.3l-30.7-38.2c-1.6-2-5-6.3-6.5-9h-0.2c0.2,2.5,0.3,7,0.3,9v38.2H32.3v-67.7h14.4l30.7,38.2 c1.7,2,5,6.3,6.6,9h0.2c-0.3-2.5-0.4-7-0.4-9v-38.2h13.9v67.7H83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#051039",
    d: "M120,253.3h-16l27.8-67.7h20.6l27.8,67.7h-16.4l-4.4-11.4h-35L120,253.3z M129.4,229h25.1l-12.6-32.7 L129.4,229z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#051039",
    d: "M246.7,185.6l-26.4,67.7h-20.6l-26.5-67.7h16.4l20.6,56.9l20.5-56.9H246.7z"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColored);
export default __webpack_public_path__ + "static/media/logo_colored.5abc2f43d428ca306f91e48865c5ba52.svg";
export { ForwardRef as ReactComponent };